var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBattery0Bar = function SvgBattery0Bar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.347 21.5a.88.88 0 0 1-.647-.26.88.88 0 0 1-.259-.644V5.144q0-.383.26-.644a.87.87 0 0 1 .644-.26h1.808V2.5h3.692v1.74h1.81q.384 0 .643.26a.88.88 0 0 1 .259.644v15.452q0 .383-.26.644a.87.87 0 0 1-.644.26zM8.94 20h6.116V5.73H8.94z"
  })));
};
export default SvgBattery0Bar;